import cx from "classnames";
import { Status } from "modules/finances/_shared";
import Link from "next/link";
import React, { CSSProperties } from "react";
import { api, FundingRequestDto } from "shared/api";
import { formatDate, formatNumber } from "shared/lib";
import { Entity } from "shared/ui";
import styles from "./funding-request-entity.module.scss";

export interface IFundingRequestEntity {
  companySlug: string;
  data: FundingRequestDto;
  href: string;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FundingRequestEntity = (props: IFundingRequestEntity) => {
  // funding request page preloading
  api.fundingRequest.useFundingRequestGet(props.companySlug, props.data.id);

  const status = props.data.status;

  const onlyAmount = status === "NEW" || status === "ADMITTED" || status === "DECLINED" || status === "CANCELED";
  const notClosed = status === "NEW" || status === "ADMITTED" || status === "APPROVED";

  const expired = notClosed && props.data.payAt?.getTime()! < new Date().getTime();

  return (
    <Entity className={cx(styles.funding_request_entity, props.className)} style={props.style} htmlId={props.htmlId}>
      <Entity.Field
        title="Оплатить"
        description={<span className={cx(expired && styles.red)}>до {formatDate(props.data.payAt)}</span>}
        label
        width={80}
      />
      <Entity.Field
        title={
          <Link href={props.href} className={styles.link}>
            №{props.data.number} {props.data.name}
          </Link>
        }
        description={props.data.fund?.name}
        width={220}
      />

      <Entity.Field title="Запрошено" description={formatNumber(props.data.amount)} label right width={85} />
      {!onlyAmount && (
        <>
          <Entity.Field title="Одобрено" description={formatNumber(props.data.approvedAmount)} label right width={85} />
          <Entity.Field title="Выплачено" description={formatNumber(props.data.paidAmount)} label right width={85} />
          {notClosed && (
            <Entity.Field
              title="К выплате"
              description={formatNumber(Number(props.data.approvedAmount) - Number(props.data.paidAmount))}
              label
              right
              width={85}
            />
          )}
        </>
      )}
      <Entity.Field right>
        <Status status={props.data.status} type="text" row="reverse" />
      </Entity.Field>
    </Entity>
  );
};

FundingRequestEntity.defaultProps = {};
